/*
 * Copyright (c) 2011 - 2021 by Curalate, Inc.
 *
 */

export const LocalesFlag: Record<string, string> = {
  'en-us': '🇺🇸',
  'fr-fr': '🇫🇷',
  'it-it': '🇮🇹',
  'de-de': '🇩🇪',
  'pl-pl': '🇵🇱',
  'ru-ru': '🇷🇺',
  'es-es': '🇪🇸',
  'en-gb': '🇬🇧',
  'en-ca': '🇨🇦',
  'fr-ca': '🇨🇦',
  'en-eu': '🇪🇺',
  'pt-br': '🇧🇷',
  'es-mx': '🇲🇽',
  'es-us': '🇺🇸',
  'sv-se': '🇸🇪',
  'nl-nl': '🇳🇱',
  'da-dk': '🇩🇰',
};
